<div class="flex flex-col h-full">
  <div class="flex items-center mb-2" aria-label="breadcrumb">
    <a routerLink="/ai-blueprints"
       (click)="onBreadcrumbBack()"
       class="label-medium cursor-pointer px-2 py-1 rounded-md hover:bg-surface text-outline">
      {{ 'AI blueprints' | translate }}
    </a>
    <span class="material-icons !text-outline-variant !text-lg">chevron_right</span>
    <span class="label-medium text-outline px-2">
      {{ (mode === 'create' ? 'Create AI blueprint' : 'Edit AI blueprint') | translate }}
    </span>
  </div>

  <div class="mt-1 flex items-start justify-between mb-6 gap-4">
    <div class="flex flex-col min-w-0">
      <input
        type="text"
        class="title-input headline-medium text-primary bg-transparent outline-none border rounded-[3px] px-2.5 py-1.5 max-w-full"
        [class.border-[#eaecf0]]="!isTitleTooLong"
        [class.border-error]="isTitleTooLong"
        [placeholder]="'Enter document title' | translate"
        [(ngModel)]="title"
        [disabled]="isLoading || isSaving || isDeleting"
        data-testid="ai-blueprint-title-input" />
      <span *ngIf="isTitleTooLong" class="label-small text-error mt-1">
        {{ 'Title must be 100 characters or less' | translate }} ({{ title.length }}/100)
      </span>
    </div>

    <div class="flex items-center gap-2 shrink-0">
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!canDelete"
        (click)="onDelete()"
        data-testid="ai-blueprint-delete-button">
        <mat-icon>delete_outline</mat-icon>
        {{ 'Delete' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!canSave"
        (click)="onSave()"
        data-testid="ai-blueprint-save-button">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>

  <div class="flex-1 min-h-0 overflow-hidden relative">
    @if (isLoading) {
      <app-loading size="lg" [label]="'Loading AI blueprint' | translate"></app-loading>
    } @else if (hasError) {
      <div class="empty-state">
        <div class="empty-state-header"></div>
        <div class="empty-state-body">
          <p class="empty-state-title text-primary">{{ 'Unable to load AI blueprint' | translate }}</p>
          <p class="empty-state-subtitle text-on-surface-variant">{{ 'Please try again later' | translate }}</p>
          <button mat-stroked-button type="button" (click)="retryLoad()" class="mt-2">
            {{ 'Try again' | translate }}
          </button>
        </div>
      </div>
    } @else {
      <div
        class="editor-card bg-white border rounded-lg w-full max-h-full h-full flex flex-col overflow-hidden"
        style="border-color: var(--color-outline-variant)">
        <div class="editor-card-header flex items-center justify-between bg-surface border-b shrink-0"
             style="border-color: var(--color-outline-variant)">
          <div class="title-medium text-on-surface-variant pl-6">
            {{ 'Instructions' | translate }}
          </div>
          <div class="flex items-center gap-3 pr-4">
            <span class="label-small text-on-surface-variant">{{ 'Default' | translate }}</span>
            <mat-slide-toggle
              [checked]="isDefault"
              [disabled]="isLoading || isSaving || isTogglingDefault"
              (click)="onToggleDefault()"
              data-testid="ai-blueprint-default-toggle">
            </mat-slide-toggle>
          </div>
        </div>

        <div class="editor-card-body flex-1 min-h-0 overflow-auto bg-white">
          <textarea
            class="instructions-textarea body-medium text-on-surface w-full h-full px-8 py-6 bg-transparent border-0 outline-none resize-none"
            [(ngModel)]="instructions"
            [disabled]="isSaving || isDeleting"
            data-testid="ai-blueprint-instructions-textarea"></textarea>
        </div>
      </div>
    }
  </div>
</div>
